module.exports = __webpack_public_path__ + "img/bull.3fe9fcf2.png";